module.exports = __webpack_public_path__ + "img/questionmark.a6ea79ad.png";